import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ListSelectTypes } from '../../../Constants/ListSelectTypes';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
@Component({
    selector: "app-list-type",
    templateUrl: "./list-type.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ListTypeComponent),
            multi: true
        }
    ],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption]
})
export class ListTypeComponent implements OnInit, ControlValueAccessor {
    val = null;
    constructor() { }
    @Input() isOfType: any;
    @Input() isOfTypes: any;
    @Input() editMode: boolean;
    @Input() singleListTypes: any;

    onChange: any = () => { };
    onTouch: any = () => { };
    setValue(val) {
        this.onChange(val);
        this.onTouch(val);
        this.val = val;
    }
    writeValue() { }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }
    ngOnInit() { }
    listTypeChange(selectedListType) {
        this.setValue(selectedListType);
    }
    public isTypeOfListEnabled(typeOfList: ListSelectTypes) {
        if (!this.isOfType) {
            return true;
        }
        const isTypeOfListSingle = this.singleListTypes.some((listType) => listType === typeOfList);
        const isOfTypeIsOfTypeListSingle = this.singleListTypes.some((listType) => listType === this.isOfType);
        return isTypeOfListSingle === isOfTypeIsOfTypeListSingle;
    }
}
